import { createRoute,lazyRouteComponent } from '@tanstack/react-router'

import { profileRoute } from '.'

const TransactionLimit = lazyRouteComponent(
  () => import('../../pages/profile/transaction-limit'),
)

export const transactionLimitRoute = createRoute({
  getParentRoute: () => profileRoute,
  path: 'transaction-limit',
  component: TransactionLimit,
})
